module.exports = __webpack_public_path__ + "static/media/woodland.7c55852f.png";